module.exports = __webpack_public_path__ + "img/酒店系统.3aa66537.png";